import { ComplaintStep } from 'features/complaint/constants'

/**
 * Utility function to determine the state of a step in the complaint flow based on the current step.
 * @param {Exclude<ComplaintStep, "confirmation">} step
 * @param {ComplaintStep} currentStep
 * @returns {"done" | "active" | "inactive"}
 */
export const getStepState = (step: Exclude<ComplaintStep, 'confirmation'>, currentStep: ComplaintStep): 'done' | 'active' | 'inactive' => {
  if (step === currentStep) return 'active'

  switch (step) {
    // Always done if the current step is not contact, since contact is the first step of the flow
    case 'contact': {
      return 'done'
    }

    case 'complaint': {
      if (currentStep === 'contact') return 'inactive'
      return 'done'
    }

    // Always inactive since overview is the last step and 'active' state is already handled above.
    case 'overview': {
      return 'inactive'
    }
  }
}
